<template>
  <div>
    <v-card>
      <v-card-title>
        <h2>Client Barcode Identifiers</h2>
        <v-spacer></v-spacer>
        <v-btn icon @click="toggleDialog">
          <v-icon>close</v-icon>
        </v-btn>
      </v-card-title>

      <v-divider></v-divider>

      <v-card-text>
        <v-container container--fluid grid-list-md>
          <v-row justify="center">
            <v-combobox
              v-model="identifiers"
              chips
              clearable
              multiple
              filled
              rounded
              append-icon=""
            >
              <template v-slot:selection="{ attrs, item, select, selected }">
                <v-chip
                  small
                  v-bind="attrs"
                  :input-value="selected"
                  close
                  @click="select"
                  @click:close="remove(item)"
                >
                  {{ item }}
                </v-chip>
              </template>
            </v-combobox>
          </v-row>
          <v-row>
            <v-btn text color="blue-grey lighten-2" @click="toggleDialog">Cancel</v-btn>
            <v-btn text color="blue darken-1" @click="saveChanges">Save</v-btn>
          </v-row>
        </v-container>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
    import axios from 'axios'

    // @group EditClient
    // Table to edit client barcodes on EditClientPage
    export default {
        name: "ClientBarcodes",
        props: {
            // Array of barcodes of the client
            clientBarcode: Array,
            // Function that toggles dialog in which are the barcodes
            toggleDialog: Function,
            // Client_id (number)
            id: Number,
        },
        data() {
            return {
              identifiers: this.clientBarcode,
            }
        },
        methods: {
            remove(value) {
              this.identifiers = this.identifiers.filter(item => item !== value)
            },
            saveChanges() {
              this.$emit('update:identifiers', this.identifiers)
              this.toggleDialog()
            },
        },
        computed: {
            // @vuese
            // Rendered Pricing array that will be displayed in the data-table (filtered by chosen region)
            // @type Array
            editPermission() {
                return this.$store.getters['auth/hasPermission']('client_edit');
            },
        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/util/Clients/ClientBarcodes.vue